module.exports = __webpack_public_path__ + "img/LsgOhr15-23.32b3739f.jpeg";